import { configureStore } from "@reduxjs/toolkit";
import walletsReducer from "./reducers/wallets.reducer";
import user from "./reducers/user";
import transactions from "./reducers/transactions.reducer";
import settingsReducer from "./reducers/settings";
import agenda from "./reducers/agenda.reducer";
import { userApi } from "./api/user-api";

const store = configureStore({
  reducer: {
    user,
    transactions,
    wallets: walletsReducer,
    settings: settingsReducer,
    agenda,
    [userApi.reducerPath]: userApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(userApi.middleware),
});

export default store;
